import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, id, readOnly, onClickAction, disabled }) => {
  return (
    <Button
      disabled={disabled}
      color="primary"
      onClick={() => onClickAction(id, readOnly)}
    >
      <EditIcon className={classes.leftIcon} />
      編集
    </Button>
  );
});

export default withStyles(styles)(button);
